import {ValueObject} from '@s-ui/domain'

export default class TaxValueObject extends ValueObject {
  /**
   * @param {Object} tax
   * @param {String} tax.type
   * @param {Number} tax.percentage
   * @param {Number} tax.amount
   * @param {Number} tax.amountLabelValue
   * */

  static validate({InvalidTaxErrorFactory, ...rest}) {
    /**
     * @return {Bool}
     * Checks if one of the parameters defined in the factory has a falsy value.
     * */
    const hasError = Object.values(rest).some(value => !value)

    if (hasError) throw InvalidTaxErrorFactory()
  }

  getTax = () => {
    return {
      type: this._type,
      percentage: this._percentage,
      amount: this._amount,
      amountLabelValue: this._amountLabelValue
    }
  }
}
